import { motion } from "framer-motion";
import { LEARNING_STEPS } from "@/data/content";

export default function LearningProcess() {
  return (
    <section id="process" data-testid="process-section" className="section bg-[#0A3161] text-white relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none opacity-30">
        <div className="absolute -top-32 -right-24 h-96 w-96 rounded-full bg-[#B31942]/30 blur-3xl" />
        <div className="absolute -bottom-32 -left-24 h-96 w-96 rounded-full bg-white/10 blur-3xl" />
      </div>
      <div className="container-x relative">
        <div className="grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-7 max-w-2xl">
            <div className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-3 py-1 text-[12px] font-semibold">
              Your 15-step journey with IIUTCStudy
            </div>
            <h2 className="mt-4 font-display font-extrabold text-4xl md:text-5xl tracking-tight" data-testid="process-heading">
              From <span className="text-[#940835]">first counseling call</span> to <span className="text-white">flying abroad</span>.
            </h2>
            <p className="mt-4 text-white/80 text-lg">
              A structured, mentor-supported process — nothing is left to chance.
            </p>
          </div>
          <div className="lg:col-span-5 relative hidden lg:block">
            <div className="relative rounded-3xl overflow-hidden border border-white/15 soft-shadow-lg">
              <img
                src="https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&w=900&q=80"
                alt="Students collaborating in a modern classroom"
                className="w-full h-64 object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A3161]/70 via-[#0A3161]/20 to-transparent" />
              <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between">
                <div>
                  <div className="text-[11px] uppercase tracking-widest text-white/70">Cohort 2026</div>
                  <div className="text-lg font-bold">Now enrolling</div>
                </div>
                <span className="rounded-full bg-[#B31942] text-white px-3 py-1 text-xs font-semibold">Live batches</span>
              </div>
            </div>
          </div>
        </div>

        {/* Desktop alternating timeline */}
        <div className="mt-14 hidden md:block relative">
          <div className="absolute left-1/2 -translate-x-1/2 top-0 bottom-0 w-px bg-white/20" />
          <div className="space-y-8">
            {LEARNING_STEPS.map((step, i) => {
              const left = i % 2 === 0;
              return (
                <motion.div
                  key={step}
                  initial={{ opacity: 0, y: 16 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.4 }}
                  className="relative grid grid-cols-2 gap-8 items-center"
                  data-testid={`step-${i + 1}`}
                >
                  <div className={left ? "" : "col-start-2"}>
                    <div className={`rounded-2xl bg-white/10 backdrop-blur border border-white/15 p-5 ${left ? "text-right" : "text-left"}`}>
                      <div className="text-[11px] uppercase tracking-widest text-white/60">Step {String(i + 1).padStart(2, "0")}</div>
                      <div className="mt-1 font-display text-xl font-bold">{step}</div>
                    </div>
                  </div>
                  <div className="absolute left-1/2 -translate-x-1/2 flex items-center justify-center">
                    <span className="h-10 w-10 rounded-full bg-[#B31942] text-white text-sm font-bold ring-4 ring-white/20 flex items-center justify-center">
                      {i + 1}
                    </span>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>

        {/* Mobile: left-aligned vertical */}
        <div className="mt-10 md:hidden relative">
          <div className="absolute left-5 top-0 bottom-0 w-px bg-white/20" />
          <div className="space-y-4">
            {LEARNING_STEPS.map((step, i) => (
              <div key={step} className="relative pl-14" data-testid={`step-m-${i + 1}`}>
                <span className="absolute left-0 h-10 w-10 rounded-full bg-[#B31942] text-white text-sm font-bold ring-4 ring-white/20 flex items-center justify-center">
                  {i + 1}
                </span>
                <div className="rounded-xl bg-white/10 backdrop-blur border border-white/15 p-4">
                  <div className="text-[11px] uppercase tracking-widest text-white/60">Step {String(i + 1).padStart(2, "0")}</div>
                  <div className="mt-0.5 font-semibold">{step}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
